import React from 'react';
import { Button, Typography, Space } from '@douyinfe/semi-ui';
import { IconLock } from '@douyinfe/semi-icons';
import { useNavigate } from 'react-router-dom';
import { PERMISSION_CONFIG } from '../../utils/auth';
import './styles/index.scss';

const { Title, Text } = Typography;

interface UnauthorizedPageProps {
  title?: string;
  description?: string;
  buttonText?: string;
  redirectPath?: string;
  onAuthorize?: () => void;
}

/**
 * 未授权访问提示页面组件
 */
const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({
  title = '抱歉，您没有权限访问该页面',
  description = '请先完成店铺授权后再访问此功能',
  buttonText = '立即前往授权',
  redirectPath = PERMISSION_CONFIG.AUTH_ROUTE,
  onAuthorize,
}) => {
  const navigate = useNavigate();

  const handleAuthorize = () => {
    if (onAuthorize) {
      onAuthorize();
    } else {
      navigate(redirectPath);
    }
  };
  return (
    <div className='unauthorized-page'>
      <div className='unauthorized-content'>
        <Space vertical spacing={24} align='center'>
          <div className='unauthorized-icon'>
            <IconLock size='extra-large' style={{ color: '#f57c00' }} />
          </div>

          <div className='unauthorized-text'>
            <Title
              heading={4}
              style={{ margin: 0, textAlign: 'center', marginBottom: '10px' }}
            >
              {title}
            </Title>
            <Text className='text-center'>{description}</Text>
          </div>

          <Button
            type='primary'
            theme='solid'
            size='large'
            onClick={handleAuthorize}
            className='authorize-button'
          >
            {buttonText}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
